import React from 'react';
import { User, Save } from 'lucide-react';

const AccountSettings = ({ formData, setFormData, onSave }) => {
 return (
 <div className="product-panel p-4 sm:p-5 md:p-6">
 <div className="mb-4 flex items-center gap-2.5">
 <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-product-md border border-border bg-surface-muted">
 <User className="h-4 w-4 text-ink" />
 </div>
 <h2 className="text-lg font-bold text-ink sm:text-xl">Account Settings</h2>
 </div>
 <div className="space-y-3 sm:space-y-4">
 <div>
 <label className="mb-1.5 block text-xs font-medium text-ink sm:mb-2 sm:text-sm">
 Full Name
 </label>
 <input
 type="text"
 value={formData.name}
 onChange={(e) => setFormData({ ...formData, name: e.target.value })}
 className="w-full rounded-product-md border border-border bg-surface px-3 py-1.5 text-xs text-ink focus:border-ink focus:outline-none focus:ring-2 focus:ring-ink sm:px-4 sm:py-2.5 sm:text-base"
 />
 </div>
 <div>
 <label className="mb-1.5 block text-xs font-medium text-ink sm:mb-2 sm:text-sm">
 Email
 </label>
 <input
 type="email"
 value={formData.email}
 disabled
 className="w-full cursor-not-allowed rounded-product-md border border-border bg-surface-muted px-3 py-1.5 text-xs text-ink-tertiary sm:px-4 sm:py-2.5 sm:text-base"
 />
 <p className="mt-1 text-xs text-ink-tertiary">Email is used for login and cannot be changed here.</p>
 </div>
 <div>
 <label className="mb-1.5 block text-xs font-medium text-ink sm:mb-2 sm:text-sm">
 Phone Number
 </label>
 <input
 type="tel"
 value={formData.phone}
 onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
 className="w-full rounded-product-md border border-border bg-surface px-3 py-1.5 text-xs text-ink focus:border-ink focus:outline-none focus:ring-2 focus:ring-ink sm:px-4 sm:py-2.5 sm:text-base"
 />
 </div>
 <button
 type="button"
 onClick={onSave}
 className="flex w-full items-center justify-center gap-2 rounded-product-md bg-ink px-4 py-1.5 text-xs font-medium text-white transition-colors hover:bg-black sm:w-auto sm:px-6 sm:py-3 sm:text-base"
 >
 <Save className="h-4 w-4" />
 <span>Save Changes</span>
 </button>
 </div>
 </div>
 );
};

export default AccountSettings;
